/** @jsx jsx */
import { jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
var footerCSS = {
  position: 'relative',
  padding: gridSize(),
  paddingBottom: gridSize() * 1.75
};

var NavigationFooter = function NavigationFooter(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: footerCSS
  }, children);
};

export default NavigationFooter;